import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import type { NotificationSettings } from "../lib/settings";

import { notifKeys } from "./query-keys";

export function usePutSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (cfg: NotificationSettings) => {
      const { data, error } = await apiClient.PUT("/v1/notifications/settings", { body: cfg });
      if (error) throw error;
      return data;
    },
    onSuccess: (data) => {
      qc.setQueryData(notifKeys.settings(), data);
    },
  });
}

export function useTestSend() {
  return useMutation({
    mutationFn: async (type: string) => {
      const { data, error } = await apiClient.POST("/v1/notifications/settings/{type}/test-send", {
        params: { path: { type } },
      });
      if (error) throw error;
      return data;
    },
  });
}
